import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // query options
      suspense: true,
      useErrorBoundary: false,
    },
    mutations: {
      // mutation options
    },
  },
});
